<script setup>
/** @typedef {import('@/models/Todo').Todo} Todo */
import { ref } from 'vue';
import AddButton from './AddButton.vue'
import { createTodo } from '@/models/CreateTodo';
// inputの入力値
const inputTodo = ref('');

// addイベントを受け取る
const emit = defineEmits(['add']);

const objectOfAttrs = {
    id: 'todo-text-box',
    type: 'text',
    placeholder: 'やることを入力',
    name: 'todo',
}

// addイベント処理で値を親に渡す
function add() {

    // createTodo でモデル化
    const todo = createTodo({
        todo: inputTodo.value,
        created_at: new Date(),
        updated_at: new Date()
    });

    // emitの引数で親に値を渡す
    emit('add', todo);
    inputTodo.value = '';
}
</script>

<template>
    <div class="grid grid-cols-4 gap-4">
        <input v-bind="objectOfAttrs" v-model="inputTodo" class="col-span-3 border-4 border-emerald-500 rounded-sm w-full px-2
     focus:outline-offset-2 focus:outline-4 focus:outline-emerald-400" />
        <AddButton label="+" @add="add" />
    </div>
</template>